import { LanguageLevel } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsInt, IsUUID } from "class-validator";

@Exclude()
export class KnownLanguage {
    @IsInt()
    @IsDefined()
    @Expose()
    public level: LanguageLevel;

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public languageId: string;
}
